import { motion } from '@eversports/react-components/design-tokens/motion'
import ActionOutcome from '@eversports/react-components/patterns/ActionOutcome'
import BaseLink from '@eversports/react-components/primitives/BaseLink'
import Button from '@eversports/react-components/primitives/Button'
import Heading from '@eversports/react-components/primitives/Heading'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { useLocation } from 'react-router-dom'
import RedirectAppTextWrapper from '../container/RedirectAppTextWrapper'
import { Localized } from '../localization/react'
import getRedirectTo from '../utils/get-redirect-to'
import getCorporatePartnerId from '../utils/get-corporate-partner-id'

// the key is the corporatePartnerId
// the value is some custom landing page url to redirect to
const CUSTOM_CORPORATE_REDIRECT_TO: { [key in string]: string } = {
  '08745158-27b4-47b9-94bf-4e096c80563e': 'https://www.eversportscorporate.com/de/dhl-eversports-hansefit/',
}

const useStyles = makeStyles({
  redirectButton: {
    maxWidth: 300,
  },
})

const container = {
  hidden: { opacity: 0, y: 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: 'easeInOut',
      delay: 0.1,
      duration: 0.2,
    },
  },
}

const button = {
  hidden: { opacity: 0, y: 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: 'easeInOut',
      delay: 0.2,
      duration: 0.2,
    },
  },
}

const AccountActivationSuccess = () => {
  const location = useLocation()

  const corporatePartnerId = getCorporatePartnerId(location)
  const customCorporateRedirectPath = corporatePartnerId && CUSTOM_CORPORATE_REDIRECT_TO[corporatePartnerId]

  const redirectTo = customCorporateRedirectPath || getRedirectTo(location)
  const classes = useStyles()

  return (
    <motion.div variants={container} initial="hidden" animate="visible">
      <ActionOutcome type="success">
        <Heading data-testid="verification-successful" is="h2">
          <Localized id="email-verification-header-success" />
        </Heading>
        <Text textAlign="center">
          <Localized id="email-verification-text-success" />
        </Text>
        <motion.span variants={button}>
          <BaseLink to={redirectTo} external data-testid="to-website">
            <Button variant="primary" className={classes.redirectButton}>
              <RedirectAppTextWrapper />
            </Button>
          </BaseLink>
        </motion.span>
      </ActionOutcome>
    </motion.div>
  )
}

export default AccountActivationSuccess
